var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddRow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 300,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.042 27.708Q20.417 27.708 20.667 27.458Q20.917 27.208 20.917 26.833V20.917H26.875Q27.208 20.917 27.458 20.667Q27.708 20.417 27.708 20.042Q27.708 19.708 27.458 19.458Q27.208 19.208 26.833 19.208H20.917V13.125Q20.917 12.792 20.667 12.542Q20.417 12.292 20.083 12.292Q19.708 12.292 19.458 12.542Q19.208 12.792 19.208 13.167V19.208H13.125Q12.792 19.208 12.542 19.458Q12.292 19.708 12.292 20.042Q12.292 20.417 12.542 20.667Q12.792 20.917 13.167 20.917H19.208V26.875Q19.208 27.208 19.458 27.458Q19.708 27.708 20.042 27.708ZM20 35.375Q16.792 35.375 13.979 34.188Q11.167 33 9.083 30.917Q7 28.833 5.812 26.021Q4.625 23.208 4.625 20Q4.625 16.75 5.812 13.938Q7 11.125 9.083 9.042Q11.167 6.958 13.979 5.792Q16.792 4.625 20 4.625Q23.25 4.625 26.062 5.792Q28.875 6.958 30.958 9.042Q33.042 11.125 34.208 13.938Q35.375 16.75 35.375 20Q35.375 23.208 34.208 26.021Q33.042 28.833 30.958 30.917Q28.875 33 26.062 34.188Q23.25 35.375 20 35.375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRow);
export default __webpack_public_path__ + "static/media/add_row.c80a2fe8afc192619d5a671080eb7a2e.svg";
export { ForwardRef as ReactComponent };